import { render, staticRenderFns } from "./appKingkongItem.vue?vue&type=template&id=514ee124"
import script from "./appKingkongItem.vue?vue&type=script&lang=js"
export * from "./appKingkongItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports